module.exports = __webpack_public_path__ + "img/product_rentrit.142ce43b.jpg";